import React from "react";

const DopPoint = ({ data, statusList, i }) => {
    const currentStatus = statusList[i];
    const nextStatus = statusList[i + 1];

    let point;

    if (currentStatus.status == "done") point = data.card_list.dop_info.big_dark_point;
    else if (currentStatus.status == "progress") point = data.card_list.dop_info.big_border_point;
    else if (currentStatus.status == "not_done") point = data.card_list.dop_info.big_trans_point;

    let bar;

    if (currentStatus.status == "done" && (nextStatus?.status == "done" || nextStatus?.status == "progress")) bar = data.card_list.dop_info.big_dark_bar;
    if (currentStatus.status == "progress" && nextStatus?.status == "not_done") bar = data.card_list.dop_info.big_dots_bar;
    if (currentStatus.status == "not_done" && nextStatus?.status == "not_done") bar = data.card_list.dop_info.big_trans_dots_bar;

    return (
        <>
            <img
                src={point}
                alt=""
            />
            {nextStatus && (<img
                src={bar}
                alt=""
                className="h-[28px] w-[2px] object-cover"
            />)}
        </>
    )
}

export default DopPoint